import minuteTemplate from './minute';
import hourTemplate from './hour';
import dayTemplate from './day';
import xDayTemplate from './xDay';
import ghDayTemplate from './ghDay';
import weekTemplate from './week';
import monthTemplate from './month';
import yearTemplate from './year';

export default [
  minuteTemplate,
  hourTemplate,
  dayTemplate,
  xDayTemplate,
  ghDayTemplate,
  weekTemplate,
  monthTemplate,
  yearTemplate,
];
